import { Injectable } from '@angular/core';
import { Html5Qrcode } from 'html5-qrcode';
import { ProcessedImage } from './processed-image.interface';

@Injectable({ providedIn: 'root' })
export class QrCodeService {
  private html5QrCode: Html5Qrcode;

  constructor() {
    this.html5QrCode = new Html5Qrcode('fakeQrReader');
  }

  async processImage(imageBlob: Blob): Promise<ProcessedImage> {
    const startTime = Date.now();
    let finalResult = '';
    try {
      const result = await this.html5QrCode.scanFileV2(
        new File([imageBlob], 'test.png', { type: imageBlob.type }),
        true
      );
      finalResult = result.decodedText;
    } catch (error) {
      console.error(error);
      return { result: 'Error: ' + error.message };
    } finally {
      const timeSeconds = Math.round(Date.now() - startTime) / 1000;
      return {
        result: finalResult,
        time: timeSeconds,
      };
    }
  }
}
